<template>
  <div>
    <ul class="npsWrapper">
        <li v-for="(item,index) in countArr" :key="index" :class="selectedIndex === index ? 'selectedItem' : ''" @click="choose(index)">
          {{item}}
        </li>
    </ul>  
    <slot></slot>
  </div>
</template>

<script>
  export default({
    props:{
      count: {
        type:Number,
        default: function(){
          return 10
        }
      },
      value: {
        type: Number
      },
      disabled: {
        type: Boolean,
        default: function(){
          return false
        }
      }
    },
    watch: {
      value (newVal) {
        this.selectedIndex = newVal
      },
      selectedIndex (newVal) {
        this.$emit('input', newVal)
      }
    },
    data(){
      return {
        selectedIndex: this.value
      }
    },
    computed: {
      countArr(){
        let arr = [];
        for(let i=1; i<this.count+1; i++){
          arr.push(i)
        }
        return arr
      }
    },
    created() {

    },
    methods: {
      choose(index){
        if(this.disabled){
          return false;
        }
        this.selectedIndex = index;
      }
    }
  })
</script>

<style scoped>
    .npsWrapper {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-top: 10px;
    }
    .npsWrapper li {
        padding: 5px 0;
        color: #000;
        font-size: 12px;
        box-sizing: border-box;
        width: 25px;
        height: 29px;
        border-radius: 2px;
        text-align: center;
        background-color: #F8F8F8;
    }
    .npsWrapper .selectedItem {
        background: #256FFF;
        color: #fff;
    }
</style>


// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/dynamicAttr/nps.vue